<template>
  <div class="taskCenter">
    <el-tabs type="card" tab-position="left" @tab-click="handleClick" v-model="activeName">
      <el-tab-pane label="我的待办" name="pending">
        <div class="main">
          <easyCruds ref="pendingTable" :tableInfo="pendingForm.mainTable" @mainTableReload="pendingTableReload"
            @doTask="doToDo" @batchAudit="batchAudit" @selection-change="selectionChange"></easyCruds>
          <batchReview :batchReview="batchReview" :selectionList="selectionList" @handleSubmit="handleSubmit">
          </batchReview>
        </div>
      </el-tab-pane>
      <el-tab-pane label="我的参与" name="processed">
        <div class="main">
          <easyCruds ref="processedTable" :tableInfo="processedForm.mainTable" @mainTableReload="processedTableReload"
            @viewApply="viewApply"></easyCruds>
        </div>
      </el-tab-pane>
      <el-tab-pane label="我的申请" name="application">
        <div class="main">
          <easyCruds ref="applicationTable" :tableInfo="applicationForm.mainTable"
            @mainTableReload="applicationTableReload" @applicationViewRow="applicationViewRow"></easyCruds>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import batchReview from '@/workFlow/dataStatistics/component/batchReview'
import { dateFormat } from '@/framework/util/date'
import { mapActions } from 'vuex'
export default {
  data() {
    return {

      activeName: 'pending',
      batchReview: {
        show: false,
        options: {},
        modeldata: {},
        showSelectList: false,
        isSign: false,
        batchAuditReferMap: {
          globalParam: {
            showTable: false,
            showDivider: false,
            showCaption: false,
            showIframe: false,
            fullscreen: false
          },
          divider: {},
          extTable: {},
          iframe: {},
          caption: {}
        }
      },
      selectionList: [],
      pendingForm: {
        mainTable: {
          buttonSetting: {
            allowView: false,
            allowEdit: false,
            allowDelete: false,
            left: [{
              title: '批量审核',
              type: 'primary',
              clickEvent: 'batchAudit'
            }]
          },
          header: {},
          table: {
            loading: false,
            height: 550,
            stripe: true,
            selection: true,
            index: false,
            columns: [
              {
                prop: 'processCode',
                label: '流程编码',
                type: 'input'
              },
              {
                prop: 'keyword',
                label: '关键字',
                isSearchCondition: true,
                type: 'input',
                showInTable: false
              },
              {
                prop: 'businessTitle',
                label: '标题',
                type: 'input'
              },
              {
                prop: 'processDefinitionKey',
                label: '流程名称',
                isSearchCondition: true,
                showInTable: false,
                type: 'select',
                dicData: []
              },
              {
                prop: 'processInstanceStartUserName',
                label: '流程申请人',
                type: 'input'
              },
              {
                prop: 'processInstanceName',
                // label: "流程实例名",
                label: '流程名称',
                type: 'input'
              },
              {
                prop: 'taskName',
                label: '当前任务名',
                type: 'input'
              },
              {
                prop: 'taskCreateTime',
                label: '环节开始时间',
                dataFilter: value => dateFormat(new Date(value)),
                type: 'input'
              }
            ],
            operation: {
              width: '140',
              operations: [
                {
                  title: '办理',
                  clickEvent: 'doTask'
                }
              ]
            },
            tableData: [],
            paging: {
              currentPage: 1,
              pageSizes: [10, 15, 20, 25],
              pageSize: 10,
              total: 0
            },
            reload: 'mainTableReload',
            reloadConditions: {},
            addDefultValue: {}
          }
        }
      },
      processedForm: {
        mainTable: {
          buttonSetting: {
            allowView: false,
            allowEdit: false,
            allowDelete: false
          },
          header: {},
          table: {
            loading: false,
            height: 550,
            stripe: true,
            selection: false,
            index: false,
            columns: [
              {
                prop: 'processCode',
                label: '流程编码',
                type: 'input'
              },
              {
                prop: 'keyword',
                label: '关键字',
                isSearchCondition: true,
                type: 'input',
                showInTable: false
              },
              {
                prop: 'businessTitle',
                label: '标题',
                type: 'input'
              },
              {
                prop: 'processDefinitionKey',
                label: '流程名称',
                isSearchCondition: true,
                showInTable: false,
                type: 'select',
                dicData: []
              },
              {
                prop: 'processInstanceStartUserName',
                label: '流程发起人',
                type: 'input'
              },
              {
                prop: 'processInstanceName',
                // label: "流程实例名",
                label: '流程名称',
                type: 'input'
              },
              {
                prop: 'taskName',
                label: '任务名称',
                dataFilter: value => value || '已完成',
                type: 'input'
              },
              {
                prop: 'taskAssigneeName',
                label: '执行人/完成人',
                type: 'input'
              },
              {
                prop: 'processStatus',
                label: '流程状态',
                type: 'input'
              },
              {
                prop: 'processInstanceStartTime',
                label: '流程发起时间',
                dataFilter: value => dateFormat(new Date(value)),
                type: 'date'
              }
            ],
            operation: {
              operations: [
                {
                  title: params => {
                    return '查看'
                  },
                  clickEvent: 'viewApply'
                }
              ]
            },
            tableData: [],
            paging: {
              currentPage: 1,
              pageSizes: [10, 15, 20, 25],
              pageSize: 10,
              total: 0
            },
            reload: 'mainTableReload',
            reloadConditions: {},
            addDefultValue: {}
          }
        }
      },
      applicationForm: {
        mainTable: {
          buttonSetting: {
            allowView: false,
            allowEdit: false,
            allowDelete: false
          },
          header: {},
          table: {
            loading: false,
            height: 550,
            stripe: true,
            selection: false,
            index: false,
            columns: [
              {
                prop: 'processCode',
                label: '流程编码',
                type: 'input'
              },
              {
                prop: 'keyword',
                label: '关键字',
                isSearchCondition: true,
                type: 'input',
                showInTable: false
              },
              {
                prop: 'businessTitle',
                label: '标题',
                type: 'input'
              },
              {
                prop: 'processDefinitionKey',
                label: '流程名称',
                isSearchCondition: true,
                showInTable: false,
                type: 'select',
                dicData: []
              },
              {
                prop: 'workflowStatus',
                label: '流程状态',
                isSearchCondition: true,
                showInTable: false,
                type: 'select',
                dicData: [
                  {
                    label: '所有',
                    value: 'all'
                  },
                  {
                    label: '已完成',
                    value: 'finish'
                  },
                  {
                    label: '处理中',
                    value: 'processing'
                  }
                ]
              },
              {
                prop: 'processInstanceStartUserName',
                label: '流程发起人',
                type: 'input'
              },
              {
                prop: 'processInstanceName',
                // label: "流程实例名",
                label: '流程名称',
                type: 'input'
              },
              {
                prop: 'taskName',
                label: '任务名称',
                dataFilter: value => value || '已完成',
                type: 'input'
              },
              {
                prop: 'taskAssigneeName',
                label: '执行人/完成人',
                type: 'input'
              },
              {
                prop: 'processStatus',
                label: '流程状态',
                type: 'input'
              },
              {
                prop: 'processInstanceStartTime',
                dataFilter: value => dateFormat(new Date(value)),
                label: '流程发起时间',
                type: 'input'
              }
            ],
            operation: {
              width: '200',
              operations: [
                {
                  title: '查看',
                  clickEvent: 'applicationViewRow'
                }
              ]
            },
            tableData: [],
            paging: {
              currentPage: 1,
              pageSizes: [10, 15, 20, 25],
              pageSize: 10,
              total: 0
            },
            reload: 'mainTableReload',
            reloadConditions: {},
            addDefultValue: {}
          }
        }
      }
    }
  },

  components: { batchReview },

  methods: {
    selectionChange(list) {
      this.selectionList = list
    },
    batchAudit() {
      this.selectionList = this.$refs.pendingTable.getSelectedRows()
      if (this.selectionList.length) {
        this.batchReview.showSelectList = false
        this.batchReview.isSign = false
        this.batchReview.batchAuditReferMap = {
          globalParam: {
            showTable: false,
            showDivider: false,
            showCaption: false,
            showIframe: false,
            fullscreen: false
          },
          divider: {
            title: '分割线'
          },
          extTable: {},
          iframe: {
            src: 'http://www.baidu.com',
            height: 200
          },
          caption: {
            value: '文字说明',
            style: 'background: rgba(246, 246, 246, 100);font-size:14px;line-height:22px'
          }
        }
        // 判断所处环节是否一致
        let taskNameArray = Array.from(new Set(this.selectionList.map(item => item.taskName)))
        if (taskNameArray.length !== 1) {
          return this.$message.error(`批量审核只能审核同一流程同一环节下的待办任务,
         你选择的任务中共存在${taskNameArray.length}个环节,包含 ${taskNameArray.toString()}`)
        } else {
          // 这里就可以进行批量审核了
          // 1.请求服务器判断选中的行能否进行批量审核
          this.$http.post('/batch-audit/valid', this.selectionList.map(item => ({
            businessKey: item.businessKey,
            taskId: item.taskId
          }))).then(response => {
            // 表单模型数据
            let formModelJson = response.data.formModelJsonList[0]
            // 批量审核字段
            let taskFormPropety = response.data.taskFormPropertyList

            let batchAuditReferMap = response.data.batchAuditReferMap
            if (batchAuditReferMap.globalParam) {
              this.batchReview.batchAuditReferMap.globalParam =
                Object.assign(this.batchReview.batchAuditReferMap.globalParam, batchAuditReferMap.globalParam)
            }
            if (batchAuditReferMap.divider) {
              this.batchReview.batchAuditReferMap.divider =
                Object.assign(this.batchReview.batchAuditReferMap.divider, batchAuditReferMap.divider)
            }
            if (batchAuditReferMap.extTable) {
              this.batchReview.batchAuditReferMap.extTable = batchAuditReferMap.extTable
            }
            if (batchAuditReferMap.iframe) {
              this.batchReview.batchAuditReferMap.iframe =
                Object.assign(this.batchReview.batchAuditReferMap.iframe, batchAuditReferMap.iframe)
            }
            if (batchAuditReferMap.caption) {
              this.batchReview.batchAuditReferMap.caption =
                Object.assign(this.batchReview.batchAuditReferMap.caption, batchAuditReferMap.caption)
            }

            // 需要批量审核的字段
            let column = formModelJson.column.filter(item => item.prop !== 'verifyFlag' && taskFormPropety.some(element => item.prop === element.id))
            column.forEach(item => {
              // item.span = 18
              if (taskFormPropety.some(element => item.prop === element.id && !element.writable && element.readable)) {
                item.disabled = true
              }
            })
            this.batchReview.options = Object.assign(formModelJson, { column })

            if (response.data.formModelJsonList.length > 1) {
              this.batchReview.isSign = true
              this.batchReview.options = response.data.formModelJsonList[1]
            }
            this.batchReview.options.column.forEach((formItem) => {
              // 选出需要绑定 blur事件的组件,其他的全部监听change事件
              let blurComponent = ['input', 'password', 'textarea']
              // 事件对列
              let changeEventQueue = []
              let clickEventQueue = []
              let blurEventQueue = []
              let focusEventQueue = []
              if (formItem.casUrl) {
                let executiveFunction = () => {
                  let bodyData = this.batchReview['modeldata']
                  bodyData['taskDefinitionKey'] = this.selectionList[0].taskDefinitionKey
                  this.$http
                    .post(`${formItem.casUrl}`, bodyData)
                    .then((response) => {
                      let columnList = response.data.columnList
                      let modifyData = {}
                      columnList.forEach((item) => {
                        if (item.hasOwnProperty('value')) {
                          // if (item.value) {
                          modifyData[item.prop] = item.value // 记录修改的value值
                        }
                        this.batchReview.options.column
                          .filter((columnItem) => columnItem.prop === item.prop)
                          .forEach((columnItem) => {
                            Object.keys(item).forEach((itemKey) => {
                              this.$set(columnItem, itemKey, item[itemKey]) // 循环修改字段属性
                            })
                            // Object.assign(columnItem, item)// 循环修改字段属性
                          })
                      })
                      // 统一修改数据
                      Object.keys(modifyData).forEach(itemKey => {
                        if (Array.isArray(modifyData[itemKey])) {
                          this.batchReview.modelData[itemKey] = []
                          modifyData[itemKey].forEach(subItem => this.batchReview.modelData[itemKey].push(this.deepClone(subItem)))
                        } else {
                          this.$set(this.batchReview.modelData, itemKey, modifyData[itemKey])
                        }
                      })
                    })
                    .catch((error) => {
                      this.$message.error(error.msg || error.message)
                    })
                }
                blurComponent.includes(formItem.type)
                  ? blurEventQueue.push(executiveFunction)
                  : changeEventQueue.push(executiveFunction)
              }
              // 事件队列写入
              if (changeEventQueue.length) {
                formItem.change = (e) => changeEventQueue.forEach((item) => item(e))
              }
              if (clickEventQueue.length) {
                formItem.click = (e) => clickEventQueue.forEach((item) => item(e))
              }
              if (blurEventQueue.length) {
                formItem.blur = (e) => blurEventQueue.forEach((item) => item(e))
              }
              if (focusEventQueue.length) {
                formItem.focus = (e) => focusEventQueue.forEach((item) => item(e))
              }
            })
            this.batchReview.show = true
          }).catch(error => this.$message.error(error.msg || error.message))
        }
      } else {
        this.$message.error('请选中至少一条数据后在进行操作')
      }
    },
    handleSubmit(data, again) {
      let dataMap = data
      dataMap.verifyFlag = again ? '2' : '1'
      let formId = this.batchReview.options.formId
      let isSign = this.batchReview.isSign
      let businessTaskList = this.selectionList.map(item => ({
        businessKey: item.businessKey,
        taskId: item.taskId,
        processInstanceId: item.processInstanceId
      }))
      this.$http.post('/batch-audit/do-task', {
        businessTaskList,
        dataMap,
        formId,
        isSign
      }).then(response => {
        // 批量成功
        this.batchReview.show = false
        this.$message.success(response.msg)
        // this.refresh()
        this.pendingTableReload({})
      }).catch(error => {
        if (error.code === 1101) {
          this.$confirm(error.msg, '温馨提示', {
            cancelButtonText: '取消',
            confirmButtonText: '确定',
            type: 'info'
          }).then(() => {
            // 反复确认
            this.handleSubmit(data, true)
          }).catch(error => {
            this.$message(error.msg || error.message)
            this.batchReview.show = false
          })
        } else {
          this.$message.error(error.msg || error.message)
        }
      })
    },
    ...mapActions(['CHANGE_TASKNUM_ASYNC']), // 改变任务中心红点
    load(params, url, data) {
      this[data].mainTable.table.loading = true
      params = params || {}
      // params.jszgh=this.jszgh;
      this[data].mainTable.table.loading = true
      if (!params.pageSize) {
        params.pageSize = 10
      }
      if (!params.pageNum) {
        params.pageNum = 1
      }
      this.$http
        .get(url, {
          params
        })
        .then(response => {
          this[data].mainTable.table.loading = false
          if (response.code === 200) {
            response.data.records
              .filter(
                item =>
                  item.taskAssigneeName === '' ||
                  item.taskAssigneeName === null ||
                  item.taskAssigneeName === ''
              )
              .forEach(item => {
                item.taskAssigneeName = item.lastExecutorName
              })
            // 成功之后的数据
            this[data].mainTable.table.tableData = response.data.records
            this[data].mainTable.table.paging.total =
              response.data.total || response.data.records.length
            return true
          } else {
            this.$message.error(response.msg)
          }
        })
        .catch(response => {
          this[data].mainTable.table.loading = false
        })
    },
    pendingTableReload(params) {
      this.load(params, '/flow-ext/my-todo-and-wait-me-claim', 'pendingForm')
    },
    processedTableReload(params) {
      this.load(params, '/flow-ext/i-did-apply', 'processedForm')
    },
    applicationTableReload(params) {
      this.load(params, '/flow-ext/my-apply', 'applicationForm')
    },
    handleClick(tab, event) {
      // this.activeName=tab.name;
    },
    getSelectData(url, label, value, columns, prop, params, method) {
      method = method || 'get'
      params = params || {}
      let HTTP =
        method === 'post'
          ? this.$http[method](url, null, { params })
          : this.$http[method](url, { params })
      let column = this[columns].mainTable.table.columns
      let index = this.findArray(column, prop, 'prop')
      HTTP.then(res => {
        let arrDate = []
        res.data.forEach(element => {
          arrDate.push({
            label: element[label],
            value: element[value]
          })
        })
        column[index].dicData = arrDate
      })
    },
    // 我的申请查看
    applicationViewRow(index, row) {
      this.$router.push({
        name: 'workFlow-view-myApply',
        query: {
          businessKey: row.businessKey,
          processInstanceId: row.processInstanceId,
          taskId: null,
          formId: null,
          pageKey: 'VIEW',
          FromId: 'application'
        }
      })
    },
    doToDo(index, row) {
      this.$router.push({
        name: 'workFlow-view-myApply',
        query: {
          businessKey: row.businessKey,
          processInstanceId: row.processInstanceId,
          taskId: row.taskId,
          formId: row.taskFormKey[0],
          pageKey: 'DO',
          FromId: 'pending'
        }
      })
    },
    // 我的参与查看
    viewApply(index, row) {
      this.$router.push({
        name: 'workFlow-view-myApply',
        query: {
          businessKey: row.businessKey,
          processInstanceId: row.processInstanceId,
          taskId: null,
          formId: null,
          pageKey: 'VIEW',
          FromId: 'processed'
        }
      })
    },

    /** 加载流程名称的select 下拉框 */
    getProcessDefinitionKeySelect(involvedMe) {
      this.$http
        .get('/flow-ext/process-definition-list', {
          params: { involvedMe }
        })
        .then(response => {
          if (response.data instanceof Array && this.$refs.mainTable) {
            let result = []
            response.data.forEach(element => {
              result.push({
                label: item.name,
                value: item.key
              })
            })

            let column = this.mainTable.table.columns
            let index = this.findArray(column, 'processDefinitionKey', 'prop')
            column[index].dicData = result
          }
        })
        .catch(error => {
          this.$message.error(error.msg || error.message)
        })
    }
  },
  created() {
    this.CHANGE_TASKNUM_ASYNC()
  },
  mounted() {
    this.pendingTableReload({})
    this.processedTableReload({})
    this.applicationTableReload({})
    // 获取流程名称列表
    this.$nextTick(() => {
      this.getProcessDefinitionKeySelect(true)
    })
    this.getSelectData(
      'flow-ext/process-definition-list',
      'name',
      'key',
      'applicationForm',
      'processDefinitionKey',
      { involvedMe: 'true' }
    )
    this.getSelectData(
      'flow-ext/process-definition-list',
      'name',
      'key',
      'processedForm',
      'processDefinitionKey',
      { involvedMe: 'true' }
    )
    this.getSelectData(
      'flow-ext/process-definition-list',
      'name',
      'key',
      'pendingForm',
      'processDefinitionKey',
      { involvedMe: 'true' }
    )
  }
}
</script>
<style lang="scss">
// .theme-longyun .avue-contail,
// .theme-longyun .avue-main {
//   margin-top: 0;
// }
.taskCenter {
  max-width: 1680px;
  width: calc(100% - 340px);
  min-width: 1280px;
  margin: auto;
  margin-top: 15px !important;
}
</style>
<style lang="scss" scoped>
:deep(.el-form-item__label) {
  color: #333;
}
.taskCenter {
  :deep(.el-tabs--card) {
    .el-tabs__header {
      width: 160px;
      margin-right: 15px;
      .el-tabs__nav {
        border: 0;
        .el-tabs__item {
          height: 48px;
          background: #fff;
          color: #666;
          line-height: 48px;
          text-align: center;
          font-size: 16px;
          border-right: 0;
          &:last-child {
            border-bottom: 0;
          }
        }
        .el-tabs__item.is-active {
          background: #1871db;
          color: #fff;
        }
      }
    }
  }
  #pane-pending :deep(.el-table__fixed-body-wrapper),
  #pane-processed :deep(.el-table__fixed-body-wrapper) {
    top: 44px !important;
  }
}
</style>
